import { Injectable, OnDestroy } from '@angular/core';
import { environment } from "../../environments/environment";
import { catchError, map } from "rxjs/operators";
import { Observable, throwError,  of as observableOf, } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Subject } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class ReportService implements OnDestroy {
  private ENDPOINT_DATASET: string = "/dremio/datasets";
  private ENDPOINT_REPORT: string = "/dremio/reports";
  private ENDPOINT_SCHEDULE_REPORT: string = "/report-schedules";

  private headerDataSubject = new Subject<any>();
  headerData$ = this.headerDataSubject.asObservable();

  sendHeaderData(data: any) {
    this.headerDataSubject.next(data);
  }

  constructor(private http: HttpClient) {}

  ngOnDestroy(): void {
    this.headerDataSubject.complete();
  }

  getDatasetList(params?: any) {
    let httpParams = new HttpParams();

    if (params) {
      httpParams = httpParams
        .set("page", params.page)
        .set("perPage", params.perPage);

      if (params.search) {
        httpParams = httpParams.set("search", params.search);
      }
    }

    return this.http
      .get(environment.report_url + this.ENDPOINT_DATASET, {
        observe: "response",
        params: httpParams,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  getFieldsByDataset(datasetName: string) {
    let params = new HttpParams();
    params = params.set("datasetName", datasetName);

    return this.http
      .get(environment.report_url + this.ENDPOINT_DATASET + "/field-metadata", {
        observe: "response",
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  getFieldOptionsByFieldName(datasetName: string, fieldName: string, typeFamily: string, search?: string){
    //https://trial-poc-api.fieldex.com/report-0.0.1-SNAPSHOT/api/dremio/datasets/field-options?typeFamily=NUMERIC&fieldName=assets_type_id&datasetName=assets
    let params = new HttpParams();
    params = params.set("datasetName", datasetName).set('fieldName',fieldName).set('typeFamily', typeFamily);
    if (search && search !== ""){
      params = params.set('searchValue', search);
    }

   // params=params.set('limit', 30);
    //params= params.set('offset', 0);
    
    return this.http
      .get(environment.report_url + this.ENDPOINT_DATASET + "/field-options", {
        observe: "response",
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  createReport(reportData: any): Observable<any> {
    return this.http
      .post(environment.report_url + this.ENDPOINT_REPORT, reportData, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  runReport(reportConfig: any): Observable<any> {
    return this.http
      .post(
        environment.report_url + this.ENDPOINT_REPORT + "/results",
        reportConfig,
        { observe: "response" }
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  geReportById(reportId: string) {
    return this.http
      .get(environment.report_url + this.ENDPOINT_REPORT + "/" + reportId, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  deleteReport(reportId: string): Observable<any> {
    let options: any = { observe: "response" };
    return this.http
      .delete(
        environment.report_url + this.ENDPOINT_REPORT + "/" + reportId,
        options
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  addToFavorite(params): Observable<any> {
    let options: any = { observe: "response" };
    // /api/dremio/reports/favorites
    return this.http
      .put(
        environment.report_url + this.ENDPOINT_REPORT + "/favorites",
        params,
        options
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  shareReport(reportParam: any): Observable<any> {
    let apiUrl: string =
      environment.report_url + this.ENDPOINT_REPORT + "/share";
    let options: any = { observe: "response" };

    return this.http.put(apiUrl, reportParam, options).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  duplicateReport(reportParam: any): Observable<any> {
    return this.http
      .post(
        environment.report_url + this.ENDPOINT_REPORT + "/duplicate",
        reportParam,
        { observe: "response" }
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  updateReport(reportParam: any): Observable<any> {
    let apiUrl: string = environment.report_url + this.ENDPOINT_REPORT;
    let options: any = { observe: "response" };

    return this.http.put(apiUrl, reportParam, options).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  exportReport(reportParam: any, type: string): Observable<any> {
    let url = environment.report_url + this.ENDPOINT_REPORT;

    console.log(type, "type in export");

    if (type == "pdf") {
      url = url + "/export-pdf";
    } else if (type == "csv") {
      url = url + "/export-csv";
    } else {
      url = url + "/export-excel";
    }

    return this.http
      .post(url, reportParam, { observe: "response", responseType: "blob" })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public exportCsv(body: any, moduleName: string) {
    let options: any = { headers: { Accept: "application/csv" } };
    options.responseType = "blob";
    return this.http
      .put<Blob>(
        `${environment.base_url}/export/module?moduleName=${moduleName}`,
        body,
        options
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  createReportSchedule(scheduleData: any): Observable<any> {
    return this.http
      .post(
        environment.report_url + this.ENDPOINT_SCHEDULE_REPORT,
        scheduleData,
        {
          observe: "response",
        }
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  getScheduleByID(scheduleId: number): Observable<any> {
    return this.http
      .get(
        environment.report_url +
          this.ENDPOINT_SCHEDULE_REPORT +
          "/" +
          scheduleId,
        {
          observe: "response",
        }
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  getScheduleByReportId(reportId: number): Observable<any> {
    return this.http
      .get(
        environment.report_url +
          this.ENDPOINT_SCHEDULE_REPORT +
          "/report/" +
          reportId,
        {
          observe: "response",
        }
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  updateReportSchedule(payload: any): Observable<any> {
    let apiUrl: string = environment.report_url + this.ENDPOINT_SCHEDULE_REPORT;
    let options: any = { observe: "response" };

    return this.http.put(apiUrl, payload, options).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  deleteReportSchedule(scheduleId): Observable<any>{
    let options: any = { observe: "response" };
    return this.http
      .delete(
        environment.report_url + this.ENDPOINT_SCHEDULE_REPORT + "/" + scheduleId,
        options
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  sendReportViaEmail(payload: any): Observable<any> {
    return this.http
      .post(
        environment.report_url + this.ENDPOINT_REPORT + "/send-via-email",
        payload,
        {
          observe: "response",
        }
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }
}
